module.exports = __webpack_public_path__ + "static/img/6.cf67050.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/6.png
// module id = WMz8
// module chunks = 0